module.exports = __webpack_public_path__ + "static/media/slideshow-38.3b444c71.jpg";